import { useCallback, useState } from 'react';
import { client, VISIBLE_SONG_STATUSES, type Song } from '../../api/client';

export function useSongs() {
  const [songs, setSongs] = useState<Song[]>([]);
  const [currentSong, setCurrentSong] = useState<Song | null>(null);

  const load = useCallback(async () => {
    const response = await client.songs.list({
      order: 'DESC',
      field: 'created_at',
      statuses: VISIBLE_SONG_STATUSES,
    });
    setSongs(response.songs);
    return response.songs;
  }, []);

  /** Load and also keep currentSong in sync if it was already set. */
  const loadAndSync = useCallback(async () => {
    const response = await client.songs.list({
      order: 'DESC',
      field: 'created_at',
      statuses: VISIBLE_SONG_STATUSES,
    });
    setSongs(response.songs);
    setCurrentSong((prev) =>
      prev ? (response.songs.find((s) => s.id === prev.id) ?? prev) : null,
    );
    return response.songs;
  }, []);

  return { songs, setSongs, currentSong, setCurrentSong, load, loadAndSync };
}
